import { render, staticRenderFns } from "./alt-logo-full.vue?vue&type=template&id=6a898579&scoped=true&"
import script from "./alt-logo-full.vue?vue&type=script&lang=ts&"
export * from "./alt-logo-full.vue?vue&type=script&lang=ts&"
import style0 from "./alt-logo-full.vue?vue&type=style&index=0&id=6a898579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a898579",
  null
  
)

export default component.exports